import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Co2FreeIcon from '@/assets/deliveryTypes/Co2FreeIcon';
import Icon99Minutos from '@/assets/deliveryTypes/Icon99Minutos';
import NexdayIcon from '@/assets/deliveryTypes/NexdayIcon';
import ReturnIcon from '@/assets/deliveryTypes/ReturnIcon';
import SameDayIcon from '@/assets/deliveryTypes/SameDayIcon';

const CARDS = [
  {
    type: 'SMD',
    title: 'Same Day',
    description: 'Genera tu guía antes de las 14:00 h y recibe tu paquete antes de las 21:00 h.',
    Icon: SameDayIcon,
  },
  {
    type: 'SPT',
    title: 'Sprint',
    description: 'Envía tu paquete hoy para que tu cliente pueda tenerlo mañana en sus manos.',
    Icon: NexdayIcon,
  },
  {
    type: '99M',
    title: '99minutos',
    description:
      'Una vez que recolectamos tu paquete empiezan a contar 99 minutos para que llegue a las manos de tu cliente.',
    Icon: Icon99Minutos,
  },
  {
    type: 'CO2F',
    title: 'CO2 Free',
    description: 'Envíos al día siguiente sin huella de carbono. *Solo disponible en CDMX.',
    Icon: Co2FreeIcon,
  },
  {
    type: 'RET',
    title: 'Retorno',
    description: 'Devuelve tu envío, sin problemas, fácil y rápido.',
    Icon: ReturnIcon,
  },
];

const SendTypes = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        width: '95%',
        overflow: 'auto',
        margin: '0 auto',
      }}
    >
      {CARDS.map(({ Icon, title, description }) => (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{
            border: `1px solid ${theme.palette.primary.main}`,
            borderRadius: '1rem',
            padding: '1rem',
            width: '100%',
            margin: '0.5rem',
            backgroundColor: 'white',
            boxShadow: theme.customShadows.z4,
            color: theme.palette.secondary.main,
            textAlign: 'start',
          }}
        >
          <Icon color="primary" fontSize="large" />
          <Typography variant="h6" mb="1rem">
            {title}
          </Typography>
          <Typography variant="body2">{description}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default SendTypes;
